import { Link } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";
import { Mail } from "lucide-react";

const LOGO_URL = "/logo-medsim-transparent.png";

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer data-testid="footer" className="bg-[#060913] border-t border-[#2a3449] py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Logo & Description */}
          <div>
            <div className="flex items-center gap-4">
              <img src={LOGO_URL} alt="MedSim" className="h-[60px] w-auto" data-testid="footer-logo" />
              <img src="https://i.ibb.co/FbRBVGbZ/Captura-de-pantalla-2026-04-18-a-las-23-13-41-gx8nfoyk46p-Mzp-KRSJUXJr2ssu3l-Yv.png" alt="Sitayag" className="h-[50px] w-auto" data-testid="footer-sitayag-logo" />
            </div>
            <p className="font-outfit text-sm text-[#64748b] leading-relaxed mt-4">
              Hospital Management Simulator
            </p>
          </div>

          {/* Nav Links */}
          <div>
            <h4 className="font-outfit text-sm text-[#f8f9fa] font-medium mb-4 uppercase tracking-wider">
              Navigation
            </h4>
            <div className="space-y-3">
              <Link
                to="/"
                data-testid="footer-home"
                className="block font-outfit text-sm text-[#64748b] hover:text-[#1a6cf5] transition-colors"
              >
                {t("nav.home")}
              </Link>
              <Link
                to="/contact"
                data-testid="footer-contact"
                className="block font-outfit text-sm text-[#64748b] hover:text-[#1a6cf5] transition-colors"
              >
                {t("nav.contact")}
              </Link>
              <Link
                to="/privacy"
                data-testid="footer-privacy"
                className="block font-outfit text-sm text-[#64748b] hover:text-[#1a6cf5] transition-colors"
              >
                {t("footer.privacy")}
              </Link>
              <Link
                to="/terms"
                data-testid="footer-terms"
                className="block font-outfit text-sm text-[#64748b] hover:text-[#1a6cf5] transition-colors"
              >
                {t("footer.terms")}
              </Link>
              <Link
                to="/legal"
                data-testid="footer-legal"
                className="block font-outfit text-sm text-[#64748b] hover:text-[#1a6cf5] transition-colors"
              >
                {t("footer.legal")}
              </Link>
              <Link
                to="/cookies"
                data-testid="footer-cookies"
                className="block font-outfit text-sm text-[#64748b] hover:text-[#1a6cf5] transition-colors"
              >
                {t("footer.cookies")}
              </Link>
              <Link
                to="/accessibility"
                data-testid="footer-accessibility"
                className="block font-outfit text-sm text-[#64748b] hover:text-[#1a6cf5] transition-colors"
              >
                {t("footer.accessibility")}
              </Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-outfit text-sm text-[#f8f9fa] font-medium mb-4 uppercase tracking-wider">
              {t("nav.contact")}
            </h4>
            <a
              href="mailto:info@sitayag.com"
              data-testid="footer-email"
              className="inline-flex items-center gap-2 font-outfit text-sm text-[#64748b] hover:text-[#1a6cf5] transition-colors"
            >
              <Mail size={14} />
              info@sitayag.com
            </a>
          </div>
        </div>

        <div className="border-t border-[#2a3449]/50 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-outfit text-xs text-[#64748b]">
            &copy; 2026 MedSim. {t("footer.rights")}
          </p>
          <div className="flex flex-wrap gap-4 md:gap-6">
            <Link to="/privacy" className="font-outfit text-xs text-[#64748b] hover:text-[#1a6cf5] transition-colors">
              {t("footer.privacy")}
            </Link>
            <Link to="/terms" className="font-outfit text-xs text-[#64748b] hover:text-[#1a6cf5] transition-colors">
              {t("footer.terms")}
            </Link>
            <Link to="/legal" className="font-outfit text-xs text-[#64748b] hover:text-[#1a6cf5] transition-colors">
              {t("footer.legal")}
            </Link>
            <Link to="/cookies" className="font-outfit text-xs text-[#64748b] hover:text-[#1a6cf5] transition-colors">
              {t("footer.cookies")}
            </Link>
            <Link to="/accessibility" className="font-outfit text-xs text-[#64748b] hover:text-[#1a6cf5] transition-colors">
              {t("footer.accessibility")}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
